import React from 'react';
import PlainButton from './PlainButton';
class CheckboxListSelection extends React.Component {

    state = {
        isChecked : this.props.checkboxListStatus === 'none' ? false : true
    }

    /* deprecated
    componentWillReceiveProps(nextProps) {
        if (nextProps.checkboxListStatus) {
          this.setState({ isChecked : nextProps.checkboxListStatus === 'none' ? false : true });
        }
    }
    */

    static getDerivedStateFromProps(nextProps, prevState) {
        // Only update state if checkboxListStatus has changed
        if (nextProps.checkboxListStatus !== undefined && nextProps.checkboxListStatus === 'none') {
            return { isChecked: false };
        } else if (nextProps.checkboxListStatus !== undefined && nextProps.checkboxListStatus !== 'none') {
            return { isChecked: true };
        }
        return null;
    }


    render() {
        const {checkboxListStatus, id} = this.props;
        const isIndeterminate = checkboxListStatus === 'partial';
        function checkIndeterminate(cb) {
            if(cb) {
                cb.indeterminate = isIndeterminate;
            }
        }
        return <React.Fragment>
                <input type="checkbox" aria-label={this.props.lableStr} id={id} ref={cb => checkIndeterminate(cb)} checked={this.state.isChecked && !isIndeterminate} onChange={() => this.props.checkboxOnClick(this.state.isChecked)} className="tde-mr-2 tde-mx-0"  />
                {this.props.lableStr}
                {this.props.showClearButton && this.props.selectedIems != 0 && <PlainButton onClick={this.props.handleClear} className="tde-mx-2 tde-s1 tde-btn-plain tde-font-weight-regular tde-text-uppercase">{this.props.getLoc('Clear')}</PlainButton>}
            </React.Fragment>;
    }
  }

export default CheckboxListSelection;
